import { Route, Routes } from "react-router-dom";
import { NotFound } from "../../misc";
import Terms from "../components/Terms";
import TermsAndConditionsSettings from "../components/TermsAndConditionsSettings";
import { getLivisUserInfo } from "../../../helpers/storage";

//component attribut will not work on v6 router version
export const TermsRoutes = () => {
  const isAuth = !!getLivisUserInfo();

  return (
    <Routes>
      <Route path="/" element={isAuth ? <TermsAndConditionsSettings /> : <Terms />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
